import { render } from "./TagsModal.vue?vue&type=template&id=5459d436&scoped=true"
import script from "./TagsModal.vue?vue&type=script&lang=js"
export * from "./TagsModal.vue?vue&type=script&lang=js"

import "./TagsModal.vue?vue&type=style&index=0&id=5459d436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5459d436"]])

export default __exports__